import type { ActivityEvent, Connection } from "./types"
import mockData from "../data/connectionsMock.json"

type MockShape = {
  connections: Connection[]
  activity: ActivityEvent[]
}

const data = mockData as MockShape

/**
 * Mock connections client — returns hardcoded data for visual demos.
 * Will be replaced with a real Nango-backed endpoint once available.
 * Keep the surface stable; only this file should change at swap time.
 */

export async function fetchConnections(): Promise<Connection[]> {
  return Promise.resolve(data.connections)
}

export async function fetchConnection(integrationId: string): Promise<Connection | null> {
  return Promise.resolve(data.connections.find((c) => c.integration_id === integrationId) ?? null)
}

export async function fetchActivity(integrationId: string, limit = 10): Promise<ActivityEvent[]> {
  const items = data.activity
    .filter((e) => e.integration_id === integrationId)
    .sort((a, b) => b.at.localeCompare(a.at))
    .slice(0, limit)
  return Promise.resolve(items)
}
